import React, { useState } from "react";
import axios from "axios";
import Style from "../Style/Adminform.module.scss";
const baseURL = process.env.REACT_APP_BASE_URL;

const Adminform = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [message, setMessage] = useState("");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedImage) {
      setMessage("❗Please choose an image.");
      return;
    }

    const formData = new FormData();
    formData.append("image", selectedImage);

    try {
      const res = await axios.post(`${baseURL}/api/upload`, formData);
      setMessage("✅ Image uploaded successfully");
      setSelectedImage(null);
      setPreview(null);
    } catch (err) {
      console.error("Upload error:", err);
      setMessage("❌ Failed to upload image");
    }
  };

  return (
    <div className={Style.formContainer}>
      <h2>Add Gallery</h2>
      {message && <p className={Style.message}>{message}</p>}
      <form onSubmit={handleSubmit} className={Style.form}>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          required
        />

        {preview && (
          <div className={Style.preview}>
            <img src={preview} alt="Preview" />
          </div>
        )}

        <button type="submit">Upload Image</button>
      </form>
    </div>
  );
};

export default Adminform;
